import { NumberInput, NumberInputProps } from "@mantine/core";

import classes from "./CurrencyInput.module.css";

import { defaultCurrency } from "@/lib/currency";

import type { FC } from "react";

export type CurrencyInputProps = {
  currencySymbol?: string;
} & Omit<NumberInputProps, "leftSection">;

export const CurrencyInput: FC<CurrencyInputProps> = ({
  currencySymbol = defaultCurrency.symbol,
  ...props
}) => {
  return (
    <NumberInput
      leftSection={currencySymbol}
      thousandSeparator=","
      decimalScale={2}
      min={0}
      classNames={classes}
      hideControls
      {...props}
    />
  );
};
